import { Layout, Type, Sparkles, Book, Zap } from "lucide-react";

export const AUDIENCE_OPTIONS = [
  "Estudantes",
  "Professores",
  "Pais",
  "Administradores",
  "Público Geral",
];

export const EXPORT_FORMATS = ["PDF", "PPTX", "Google Slides"];

export const SLIDE_COUNT_OPTIONS = [
  { value: "10", label: "10 slides" },
  { value: "15", label: "15 slides" },
  { value: "20", label: "20 slides" },
  { value: "25", label: "25 slides" },
  { value: "30", label: "30 slides" },
];

export const COLOR_SCHEMES = {
  blue: { value: "blue", label: "Azul", color: "#1967d2" },
  green: { value: "green", label: "Verde", color: "#188038" },
  purple: { value: "purple", label: "Roxo", color: "#9334e6" },
  red: { value: "red", label: "Vermelho", color: "#d93025" },
  dark: { value: "dark", label: "Escuro", color: "#202124" },
};

export const SLIDE_STYLES = [
  {
    value: "minimal",
    label: "Minimalista",
    description: "Limpo e focado",
    icon: Layout,
    color: "#188038",
  },
  {
    value: "educational",
    label: "Educacional",
    description: "Amigável e dinâmico",
    icon: Book,
    color: "#1967d2",
  },
  {
    value: "corporate",
    label: "Corporativo",
    description: "Profissional e formal",
    icon: Sparkles,
    color: "#9334e6",
  },
  {
    value: "creative",
    label: "Criativo",
    description: "Inovador e colorido",
    icon: Zap,
    color: "#d93025",
  },
  {
    value: "data-driven",
    label: "Dados",
    description: "Com gráficos e números",
    icon: Type,
    color: "#ea8600",
  },
];

export const MESSAGES = {
  generating: "Criando seus slides...",
  generatingDesc:
    "Nossa IA está criando uma apresentação personalizada para você",
  generateBtn: "Gerar Apresentação com IA",
  saving: "Salvando apresentação...",
  loading: "Carregando...",
  success: "Apresentação Gerada com IA",
  error: "Erro ao gerar slides",
  empty: "Nenhuma apresentação salva",
};

export const COLOR_VALUES = {
  blue: "#1967d2",
  green: "#188038",
  purple: "#9334e6",
  red: "#d93025",
  dark: "#202124",
};

export const BG_COLOR_VALUES = {
  blue: "#e8f0fe",
  green: "#e6f4ea",
  purple: "#f3e8ff",
  red: "#fce8e6",
  dark: "#f1f3f4",
};
